import * as React from 'react'
import { Typography } from '@mui/material';


export default function retailerColumn() {
    return [{
		name: 'seller', label: 'Seller',
		options: {
			display: 'excluded',
		}
	},{
        name: 'seller', label: 'Seller',
        options: {
			headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value) => <Typography variant='body2' sx={{ fontSize: '0.8rem'}}>{value}</Typography>
        }
    }]
}